import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { useFiltersStore } from '@/stores/filtersStore'

/** First path segment: `/customers/12/view` → `customers`. */
function moduleSegment(pathname: string): string {
  return pathname.split('/')[1] ?? ''
}

/**
 * Clears every listing's search / filter / sort selection when the user
 * leaves one module for another (Customers → Events, …). Moving within a
 * module — open a record, come back to the grid — keeps the selection.
 * Client feedback, 2026-10-08.
 */
export function useClearFiltersOnModuleChange(): void {
  const module = moduleSegment(useLocation().pathname)
  const clearAll = useFiltersStore((state) => state.clearAll)
  const previousModule = useRef(module)

  useEffect(() => {
    if (previousModule.current === module) return
    previousModule.current = module
    clearAll()
  }, [module, clearAll])
}
